<script type="ts">
    import {t} from "i18n-js";
    import Flyout from "./Flyout.svelte";
    import {checkoutUrl} from '../../nutsandwoods';
    import {restartPopupLogic} from '../../parts/newsletter';
    import initializeHoverFlip from '../../hover-flip';

    import { onMount } from 'svelte';
    import { isPhone } from "../../svelte/useragent";

    const SCOPE = {scope: 'Cart.Indicator'};

    let flyout: Flyout;

    let itemsCount: number;

    (async () => {
        const {cart} = await import('../../yoocon-shop');
        cart.on('update', () => {
            const count = cart.count();
            if(itemsCount !== undefined && count > itemsCount) {
                if(document.body.id != 'page-checkout')
                    flyout.flash();
                restartPopupLogic();
            }
            itemsCount = count;
        });
    })();

    onMount(() => {
        initializeHoverFlip();
    });
</script>

<a id="cart-link" class="effect-hover-flip" href={checkoutUrl()}
    data-content={`${t('title', SCOPE)} (${itemsCount ?? 0})`}
    on:mouseenter={() => { if(!$isPhone) flyout.show(); }}
    on:mouseleave={() => { if(!$isPhone) flyout.hide(); }}
>
    <span>
        <span><span>{t('title', SCOPE)}</span></span>
        <span>({itemsCount ?? 0})</span>
    </span>
</a>

<Flyout bind:this={flyout} />
